/**
 * Copyright (c) 2017.  INTERIA.PL (www.interia.pl)
 **/

/**
 * Created by vladyslav on 27.11.17.
 */
import { outerHeightWithMargin } from './helper';
import { OFFSET_TOP } from './config';

export default class Ad {

    constructor({ element, adsSidebar, place, minVisibilityRange = 0, maxVisibilityRange = 0, height = 0, w }) {

        this.element = element; // ad html element
        this.adsSidebar = adsSidebar; // sidebar html element
        this.place = place; // Nazwa miejsca reklamowego
        this.minVisibilityRange = minVisibilityRange;
        this.maxVisibilityRange = maxVisibilityRange;
        this.height = height; // ad height
        this.w = w;

    }

    /**
     * count ad's position
     * @param sidebar
     */
    updatePosition(sidebar) {

        const { style } = this.element;

        let positionTop = Ad.calcPositionTop(sidebar);

        if (positionTop <= this.minVisibilityRange) {
            // ad position when positionTop value is between min/max
            style.top = `${ this.minVisibilityRange }px`;
            style.position = 'absolute';

        } else if (this.maxVisibilityRange <= positionTop) {
            // ad position when positionTop value is greater then max
            style.top = `${ this.maxVisibilityRange }px`;
            style.position = 'absolute';

        } else {
            // fix ad on top
            style.top = `${ OFFSET_TOP }px`;
            style.position = 'fixed';
        }
    }

    /**
     * calculate top position
     * @param sidebar
     * @returns {number}
     */
    static calcPositionTop(sidebar) {
        return window.pageYOffset - sidebar.offsetTop;
    }

    calcVisibilityRange(sidebar) {

        const { ads, adHeights, contentHeight } = sidebar;
        const adsLength = ads.length;
        const prevAdsHeight = this.calcPrevAdsHeights(sidebar);
        const { innerHeight } = this.w;
        const index = this.index(sidebar); // ad's id
        const lastAd = this.isLast(sidebar);
        const movableAdsQuantity = Math.max(2, adsLength) - 1;

        let sidebarHeight;
        let height;

        if (innerHeight > 600) {
            sidebarHeight = (innerHeight / 6) + adHeights;

        } else {
            sidebarHeight = 0;
        }
        height = sidebarHeight;

        // count min visibility value
        this.minVisibilityRange = Math.max(prevAdsHeight, height * index / movableAdsQuantity);
        // count max visibility value
        this.maxVisibilityRange = height * (index + 1) / movableAdsQuantity;

        if (adsLength > 1) {
            this.height = outerHeightWithMargin(this.element);
            this.maxVisibilityRange -= this.height;//outerHeightWithMargin(this.element);
        }

        if (this.maxVisibilityRange < 0) {
            // fix max visibility value if it has minus value
            this.maxVisibilityRange = 0;
        }

        if (lastAd) {
            // to do last ad visible at the end of page
            // do max visibility with main content
            this.maxVisibilityRange = contentHeight - this.height;// - (this.height / 10);
        }
    }

    /**
     * calculate previous ads heights
     * @param sidebar
     * @returns {*}
     */
    calcPrevAdsHeights(sidebar) {
        let prevAds = this.prevAds(sidebar);
        return prevAds.reduce((height, ad) => height + outerHeightWithMargin(ad.element), 0);
    }

    /**
     * get previous ads
     * @param sidebar
     * @returns {Array.<T>}
     */
    prevAds(sidebar) {
        return sidebar.ads.slice(0, this.index(sidebar));
    }

    /**
     * move to the next ad
     * @param ads
     * @returns {*}
     */
    nextAd({ ads }) {
        const idx = ads.indexOf(this);
        if (idx + 1 < ads.length) {
            return ads[idx + 1];
        }

        return ads[idx];
    }

    /**
     * get ad's index
     * @param ads
     */
    index({ ads }) {
        return ads.indexOf(this);
    }

    /**
     * get last ad
     * @param sidebar
     * @returns {boolean}
     */
    isLast(sidebar) {
        return this === sidebar.getLastAd();
    }
}



// WEBPACK FOOTER //
// ./source/Ad.js